// extracted by mini-css-extract-plugin
module.exports = {"mainHeading":"Header_mainHeading__2DFJb","text":"Header_text__1QGkm","image":"Header_image__1NIi_","textFirst":"Header_textFirst__3am_K"};